<template>
  <VDialogV3
    id="person-card"
    position="right"
    width="600px"

    :entity="localPerson"
    :loading="isLoading"

    :context-menu="localPerson.isExisting ? PersonsService.contextMenu : null"

    :submit-disabled="isSaveDisabled"
    @submit="onSubmit"
  >
    <section class="person-info">
      <header>Основная информация</header>

      <VInput
        ref="person-name"
        v-model="localPerson.name"
        label="ФИО"
        layout="vertical"
        required
      />

      <VInput
        ref="person-email"
        v-model="localPerson.email"
        label="Email"
        layout="vertical"
        type="email"
        required
      />

      <VSelect
        ref="person-timezone"
        v-model="localPerson.timeZone"
        placeholder="Введите название города"
        label="Часовой пояс"
        layout="vertical"
        option-label="stringRepresentation"
        :options="timeZoneOptions"
        required
      />

      <VTextarea
        ref="person-comment"
        v-model="localPerson.comment"
        label="Комментарий"
        layout="vertical"
      />
    </section>

    <section>
      <VSelect
        v-if="isSWPartner"
        v-model="localPerson.swPortalEmployee"
        placeholder="Введите ФИО сотрудника"
        label="Сотрудник в ИС Сибирского здоровья"
        layout="vertical"
        :search-function="SWPortalTaskService.searchEmployees"
      />
    </section>

    <hr>

    <ContactsSection
      ref="contactsSection"
      :person="localPerson"
      :edit-mode="localPerson.isExisting"
      @contact:updated="() => $emit(Person.Events.Updated)"
      @contact:deleted="() => $emit(Person.Events.Updated)"
    />
  </VDialogV3>
</template>

<script lang="ts">

import Person               from "@/domains/Persons/Person";
import PersonsService       from "@/domains/Persons/PersonsService";
import PartnersService      from "@/domains/Partners/PartnersService";
import TimeZonesService     from "@/domains/TimeZones/TimeZonesService";
import ContactsService      from "@/domains/Contacts/ContactsService";
import SWPortalTasksService from '@/domains/SWPortalTask/SWPortalTasksService';
import TimeZone             from "@/domains/TimeZones/TimeZone";

import ContactsSection      from "@/domains/Contacts/components/ContactsSection/ContactsSection.vue";

export default defineComponent({
  name: "PersonCard",

  components: {
    ContactsSection,
  },

  props: {
    person: {
      type: Person,
      default: null,
    },
  },

  data() {
    const localPerson = this.$core.utils.cloneDeep(this.person);

    return {
      Person,
      ContactsService,
      TimeZonesService,
      PersonsService,
      PartnersService,

      localPerson,

      SWPortalTaskService: SWPortalTasksService,
      timeZoneOptions: [] as TimeZone[],
    }
  },

  computed: {
    /**
     * Лоадер диалога. entity (localPerson) есть всегда (клонируется в data),
     * поэтому грузим вручную: показываем лоадер, пока не подтянули список
     * часовых поясов.
     */
    isLoading() {
      return this.timeZoneOptions.length === 0;
    },
    isSWPartner() {
      return this.$core.currentUser.isPrivileged
        && this.$core.currentUser.isAdmin
        && this.$core.currentUser?.canEditPaymentExternalId;
    },
    isSaveDisabled() {
      if (!this.localPerson.isExisting) {
        return false;
      }
      else {
        return this.$core.utils.isEqual(this.person, this.localPerson);
      }
    },
  },

  async created() {
    await this.initTimezoneList();
  },

  methods: {
    async initTimezoneList() {
      this.timeZoneOptions = await TimeZonesService.getList();
    },

    /**
     * Единый обработчик сабмита. VDialogV3 уже прогнал валидацию формы
     * перед эмитом submit, поэтому здесь валидация не вызывается.
     * Ветвление: новое лицо — создаём, существующее — обновляем
     * (сначала контакты в ContactsSection, затем само лицо).
     */
    async onSubmit() {
      if (this.localPerson.isExisting) {
        await this.updatePerson();
      }
      else {
        await this.createPerson();
      }
    },

    async createPerson() {
      const createdPerson = await PersonsService.add(this.localPerson, this.localPerson.partnerId);

      if (!createdPerson) return;

      this.$emit(Person.Events.Created, createdPerson);
    },

    async updatePerson() {
      /** ждем обновления или создания контактов в ContactsSection */

      await (this.$refs.contactsSection as any).updateContacts();

      /** затем делаем обновление контактного лица */

      if (await PersonsService.update(this.localPerson)) {
        this.$emit(Person.Events.Updated, this.localPerson);
      }
    },
  },
})
</script>
